import { render, staticRenderFns } from "./SchoolName.vue?vue&type=template&id=3abdbe5d&"
import script from "./SchoolName.vue?vue&type=script&lang=js&"
export * from "./SchoolName.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports